import { lazy } from 'react';

export default (componentImport) => {
  return lazy(
    () => componentImport,
  );
};
